// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Y_Bq","options":"AnswerScale_options__2KeXF","selected":"AnswerScale_selected__2deCg"};